import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppQuery } from "../../../api/fetchClient";
import { QUERY_KEYS } from "../../../api/queryKeys";
import { GET_USER_DETAILS } from "../../../api/url";
import Loader from "../../../components/common/Loader";
import { arrowBack, ProfileImage } from "../../../assets/image";

function UserDetails() {
  const navigate = useNavigate();
  const location = useLocation();

  const [details, setDetails] = useState({});

  const { data, isLoading } = useAppQuery({
    queryKey: [QUERY_KEYS.USER_DETAILS, location?.state?.userId],
    url: `${GET_USER_DETAILS}?userId=${location.state?.userId}`,
  });

  useEffect(() => {
    if (!!data) {
      setDetails(data?.results);
    }
  }, [data]);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div className="bg-[#f8f9fa] min-h-screen">
      <div className="flex gap-2 mb-5">
        <button onClick={() => navigate(-1)}>
          <img src={arrowBack} alt="" />
        </button>
        <div className="text-2xl text-primary font-semibold">User details</div>
      </div>
      <div className="bg-white rounded-xl shadow-md p-6 flex items-center gap-6 mb-6">
        {details?.profileImage ? (
          <img src={details?.profileImage} alt="Profile" className="w-24 h-24 rounded-full object-cover" />
        ) : (
          <div className="w-24 h-24 rounded-fulloverflow-hidden">
            <img src={ProfileImage} alt="" />
          </div>
        )}
        <div className="flex flex-col">
          <h2 className="text-xl font-semibold text-primary mb-1">{details?.userName ? details?.userName : "-"}</h2>
          <p className="text-grey">
            {details?.mobileNumber ? details?.countryCode + " " + details?.mobileNumber : "-"}
          </p>

          <p className="text-sm text-light">
            {details?.state ? details?.state + "," : "-"}
            {details?.country}
          </p>
          <p>{details?.bio}</p>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6 mb-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-primary">Personal Information</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-gray-700">
          <div className="grid">
            <strong>Name</strong> {details?.name ? details?.name : "-"}
          </div>

          <div className="grid">
            <strong>Date of Birth</strong> {details?.dob ? details?.dob : "-"}
          </div>
          <div className="grid">
            <strong>Gender</strong> {details?.gender ? details?.gender : "-"}
          </div>
          <div className="grid">
            <strong>Religion</strong>
            {details?.religion ? details?.religion : "-"}
          </div>
          <div className="grid">
            <strong>Community</strong>
            {Array.isArray(details?.community) && details.community.map((c, index) => <span key={index}>{c}</span>)}
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-primary">Address</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-gray-700">
          <div className="grid">
            <strong>Country</strong>
            {details?.country ? details?.country : "-"}
          </div>
          <div className="grid">
            <strong>State</strong>
            {details?.state ? details?.state : "-"}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserDetails;
